
import {CheckOutlined} from '@ant-design/icons-vue';

export default {
  name: 'ElePredefine',
  components: {CheckOutlined},
  emits: ['update:color'],
  props: {
    // 颜色列表
    colors: {
      type: Array,
      required: true
    },
    // 选中的颜色
    color: String
  },
  methods: {
    /* 颜色选中 */
    handleSelect(color) {
      this.$emit('update:color', color);
    }
  }
};
